import * as Yup from "yup";
import { dictRegExp } from "../../../utils/helpers/regex.helpers";

const userFormSchema = Yup.object().shape({
  userName: Yup.string().required("Введите имя пользователя"),
  userGroupId: Yup.number().required("Выберите роль"),
  email: Yup.string()
    .nullable(true)
    .test("email", "Проверьте корректность данных  __@__.__", (val) => {
      if (val?.trim()) {
        return dictRegExp.email.test(val);
      }
      return true;
    })
    .required("Введите email"),
  surname: Yup.string().required("Введите фамилию"),
  name: Yup.string().required("Введите имя"),
  organizationName: Yup.string().required("Выберите организацию"),
});

export default userFormSchema;
